import {
  BankOutlined,
  CheckSquareOutlined,
  FileTextOutlined,
  MailOutlined,
  MessageOutlined,
  PhoneOutlined,
  ShoppingCartOutlined,
  UserAddOutlined,
} from '@ant-design/icons';
import { Spin, Timeline } from 'antd';
import React, { useState } from 'react';
import { useNavigate } from 'react-router';
import { WL_CONFIG } from 'constants';
import ActivityItem from './ActivityItem';

const TYPE_ICONS = {
  note: FileTextOutlined,
  task: CheckSquareOutlined,
  call: PhoneOutlined,
  email: MailOutlined,
  sms: MessageOutlined,
  order: ShoppingCartOutlined,
  customer_created: UserAddOutlined,
  company_created: BankOutlined,
};

const TYPE_COLORS = {
  note: '#52c41a',
  task: '#fa8c16',
  order: '#722ed1',
  call: '#73d13d',
  email: '#1890ff',
  sms: '#13c2c2',
  customer_created: '#8c8c8c',
  company_created: '#8c8c8c',
};

function ActivityTimeline({ activities, onLoadMore, loadingMore, hasReachedEnd }) {
  const [expanded, setExpanded] = useState({});
  const navigate = useNavigate();

  const toggleExpand = (id) => {
    setExpanded((prev) => ({ ...prev, [id]: !prev[id] }));
  };

  const getOrderId = (metadata) => metadata?.order_id;

  const showLoadMore = onLoadMore && !hasReachedEnd;
  const showEndMessage = hasReachedEnd && activities.length > 0;

  return (
    <div className="activity-timeline-wrapper">
      <Timeline
        className="activity-timeline"
        items={activities.map((item) => {
          const Icon = TYPE_ICONS[item.type] || FileTextOutlined;
          const color = TYPE_COLORS[item.type] ?? '#8c8c8c';
          const isExpanded = expanded[item.id];
          const orderId = item.type === 'order' ? getOrderId(item.metadata) : null;

          return {
            dot: (
              <span className="activity-timeline-dot" style={{ borderColor: color, color }}>
                <Icon style={{ fontSize: 22 }} />
              </span>
            ),
            children: (
              <ActivityItem
                item={item}
                isExpanded={isExpanded}
                onToggleExpand={() => toggleExpand(item.id)}
                orderId={orderId}
                onOrderClick={() => orderId && navigate(`/console/orders/${orderId}`)}
                borderColor={color}
              />
            ),
          };
        })}
      />
      {showLoadMore && (
        <div className="activity-load-more-footer">
          <button
            type="button"
            className="activity-load-more-btn"
            onClick={onLoadMore}
            disabled={loadingMore}
            style={{ color: WL_CONFIG.colors.primary }}
          >
            {loadingMore ? (
              <>
                <Spin size="small" style={{ marginRight: 8 }} />
                View More
              </>
            ) : (
              'View More'
            )}
          </button>
        </div>
      )}
      {showEndMessage && (
        <div className="activity-end-message">No Additional Activity To Show</div>
      )}
    </div>
  );
}

export default ActivityTimeline;
